import { fetchPosts } from "../../api/posts";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { PostsActions } from "./actions";

const workerFetchPosts = function* (): Generator<any> {
    const response = yield call(fetchPosts);
    yield put({ type: PostsActions.FETCH_POSTS_SUCCESS, payload: response })
    console.log('Fetching posts')
}

export function* watcherPostsActions() {
    yield all([
        takeEvery(PostsActions.FETCH_POSTS, workerFetchPosts),
    ])
}